module.exports = __webpack_public_path__ + "img/icon_1_20.84fa27be.png";